import { message } from 'antd'
import { ErrorContext } from 'context'
import { getApiTargetInfo } from 'core'
import Task from 'data.task/lib/task'
import { useContext, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

export const useErrorModal = () => {
  const { setError } = useContext(ErrorContext)
  return [setError, null]
}

export const usePmgrApi = (apiFunction, options = {}) => {
  if (apiFunction == null)
    throw new Error('Api function (First Argument) must be a function')
  const [inProgress, setInProgress] = useState(false)
  const targetInfo = useSelector(getApiTargetInfo)
  const { successMessage = '' } = options

  const caller = useMemo(() => {
    // inject target info
    const apiCaller = apiFunction(targetInfo)
    function memoCaller() {
      return new Task((_, resolve) => {
        setInProgress(true)
        resolve()
      }).chain(() =>
        apiCaller.apply(null, arguments).bimap(
          e => {
            setInProgress(false)
            return e
          },
          resp => {
            if (
              successMessage != null &&
              successMessage !== '' &&
              typeof successMessage === 'string'
            )
              message.success(successMessage)
            if (successMessage != null && typeof successMessage === 'function')
              message.success(successMessage(resp))
            setInProgress(false)

            return resp
          }
        )
      )
    }
    return memoCaller
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successMessage, targetInfo])

  return [caller, inProgress]
}
